<template>
    <div class="step1-wrapper" v-if="application">
        <ValidationObserver
                v-slot="{ handleSubmit }"
                ref="applicantForm"
        >
            <form class="uk-form" @submit.prevent="handleSubmit(create)" autocomplete="chrome-off">
                <div class="renter-homeowner-wrapper uk-padding-top uk-margin-bottom-large" >
                    <div class="uk-display-inline" >
                        <span v-if="application.program.rent_program">
                            <label id="i_am_a" class="custom" for="base-radio" style="padding-right: 15px">
                                {{ __('global.i_am_a') }} <span class="uk-visible-small">:</span>
                            </label><hr class="uk-visible-small">

                            <label id="label_renter" class="custom" for="renter-radio">
                                <input type="radio" id="renter-radio" name="renter-homeowner-radio" value="renter"  v-model="submitData.mainType" :checked="!application.program.mortgage_program && application.program.rent_program" aria-labelledby="i_am_a label_renter" autofocus>
                                {{ __('global.renter') }}
                            </label>
                        </span>

                        <span v-else>
                            <label class="custom" for="base-radio" style="padding-right: 15px">
                                {{ __('global.i_am_a') }} <span class="uk-visible-small">:</span>
                            </label><hr class="uk-visible-small">
                        </span>
                    </div>
                    <div class="uk-display-inline uk-margin-left" v-if="application.program.mortgage_program">
                        <br class="uk-visible-small"><input type="radio" id="homeowner-radio" name="renter-homeowner-radio" value="homeowner" v-model="submitData.mainType" :checked="application.program.mortgage_program && !application.program.rent_program">
                        <label class="custom" for="homeowner-radio">{{ __('global.homeowner') }}</label>
                    </div>
                </div>

                <fieldset class="uk-margin-top">
                    <legend class="">{{ __('tenant.primary_applicant') }}</legend>
                    <div class="uk-container">
                        <div class="uk-grid">
                            <div class="uk-width-medium-1-2 uk-margin-bottom">
                                <TextInput
                                        v-model="applicant.first_name"
                                        :name="__('tenant.first_name')"
                                        :placeholder="__('tenant.first_name')"
                                        rules="required"
                                        :label="__('tenant.first_name')"
                                />
                            </div>
                            <div class="uk-width-medium-1-2 uk-margin-bottom">
                                <TextInput
                                        v-model="applicant.last_name"
                                        :name="__('tenant.last_name')"
                                        :placeholder="__('tenant.last_name')"
                                        rules="required"
                                        :label="__('tenant.last_name')"
                                />
                            </div>
                            <ul v-if="usingScreenReader" aria-label="How to use datePicker" class="uk-width-1-1">
                                <li>Use Arrow Keys to navigate between days.</li>
                                <li>previous year: Control + Command + Arrow Up</li>
                                <li>Next year: Control + Command + Arrow Down</li>
                                <li>previous month: Control + Command + Arrow Left</li>
                                <li>Next month: Control + Command + Arrow Right</li>
                                <li>Select Date: Enter</li>
                            </ul>
                            <div class="uk-width-medium-1-4 uk-margin-bottom">
                                <date-picker
                                        :name="__('tenant.birth_date')"
                                        :label="__('tenant.birth_date')"
                                        v-model="applicant.dob"
                                        :config="applicantDatePickerConfig"
                                        :placeholder="__('tenant.birth_date')"
                                        rules="required"
                                /> <a v-if="!usingScreenReader" uk-tooltip title="HOW TO ENTER YOUR BIRTHDATE" onclick="UIkit.modal.alert('<div class=\'uk-grid\'><div class=\'uk-width-1-1 uk-margin-bottom\'><h1>How to Use the Calendar Field</h1></div><div class=\'uk-width-1-2\'><h3><strong>How to enter your birth date: <ul><li>Click on the field to open the calendar.</li><li>Click on the month to select your birth month.</li><li>Double click on the year to select it, and type in your birth year.</li><li>Click on your birth day</li><li>The calendar modal will close automatically.</li></ul></h3></div><div class=\'uk-width-1-2\'><img src=\'/images/calendar-how-to.gif\'></div></div>');" class="uk-dark uk-light use-hand-cursor theme-primary-bg-color" style="position: relative; top: -55px; float: right; margin-right: 5.85px; padding: 0px; font-size: 14px; background-color: #6495d1; width: 20px; height: 20px; display: block; border-radius: 10px; text-align: center; color:white">?</a>
                                <validated-section :errors="errors" field="applicant_dob">
                                </validated-section>
                            </div>
                            <ul v-if="usingScreenReader" aria-label="Explanation from the HUD Race" class="uk-width-1-1">
                                <li>American Indian or Alaska Native: A person having origins in any of the original peoples of North and South America (including Central America), and who maintains tribal affiliation or community attachment.</li>
                                <li>Asian: A person having origins in any of the original peoples of the Far East, Southeast Asia, or the Indian subcontinent including, for example, Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand, and Vietnam.</li>
                                <li>Black or African American: A person having origins in any of the black racial groups of Africa. Terms such as “Haitian” can be used in addition to “Black” or “African American.”</li>
                                <li>Native Hawaiian or Other Pacific Islander: A person having origins in any of the original peoples of Hawaii, Guam, Samoa, or other Pacific Islands.</li>
                                <li>White: A person having origins in any of the original peoples of Europe, the Middle East or North Africa.</li>
                            </ul>
                            <div class="uk-width-medium-1-4 uk-margin-bottom">
                                <label>{{ __('tenant.race') }}: <a v-if="!usingScreenReader" uk-tooltip title="EXPLANATION FROM THE HUD RACE" onclick="UIkit.modal.alert('<div class=\'uk-grid\'><div class=\'uk-width-1-1 uk-margin-bottom\'><h1>Explanation from the HUD Race</h1></div><div class=\'uk-width-1-1\'><ul><li><strong>American Indian or Alaska Native: </strong>A person having origins in any of the original peoples of North and South America (including Central America), and who maintains tribal affiliation or community attachment.</li><li><strong>Asian: </strong>A person having origins in any of the original peoples of the Far East, Southeast Asia, or the Indian subcontinent including, for example, Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand, and Vietnam.</li><li><strong>Black or African American: </strong>A person having origins in any of the black racial groups of Africa. Terms such as “Haitian” can be used in addition to “Black” or “African American.” </li> <li><strong>Native Hawaiian or Other Pacific Islander: </strong>A person having origins in any of the original peoples of Hawaii, Guam, Samoa, or other Pacific Islands. </li> <li><strong>White: </strong>A person having origins in any of the original peoples of Europe, the Middle East or North Africa. </li> </ul></div></div>');" class="uk-dark uk-light use-hand-cursor theme-primary-bg-color" style="top: -55px; float: right; margin-right: 5.85px; padding: 0px; font-size: 14px; background-color: #6495d1; width: 20px; height: 20px; display: block; border-radius: 10px; text-align: center; color:white">?</a></label>
                                <validated-section :errors="errors" field="applicant_race">
                                <select :aria-label="__('tenant.race')" v-model="applicant.race_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.races" :key="item.id" :value="item.id">{{item.race_desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <ul v-if="usingScreenReader" aria-label="Explanation from the Ethnicity" class="uk-width-1-1">
                                <li>Hispanic or Latino: A person of Cuban, Mexican, Puerto Rican, South or Central American, or other Spanish culture or origin, regardless of race. The term “Spanish origin” can be used in addition to “Hispanic” or “Latino.”</li>
                                <li>Not Hispanic or Latino: A person not of Cuban, Mexican, Puerto Rican, South or Central American, or other Spanish culture or origin, regardless of race.</li>
                            </ul>
                            <div class="uk-width-medium-1-4 uk-margin-bottom">
                                <label>{{ __('tenant.ethnicity') }}:<a v-if="!usingScreenReader" uk-tooltip title="EXPLANATION FROM THE ENTHENTICITY" onclick="UIkit.modal.alert('<div class=\'uk-grid\'><div class=\'uk-width-1-1 uk-margin-bottom\'><h1>Explanation from the Ethnicity</h1></div><div class=\'uk-width-1-1\'><ul><li><strong>Hispanic or Latino: </strong>A person of Cuban, Mexican, Puerto Rican, South or Central American, or other Spanish culture or origin, regardless of race. The term “Spanish origin” can be used in addition to “Hispanic” or “Latino.”</li><li><strong>Not Hispanic or Latino: </strong>A person not of Cuban, Mexican, Puerto Rican, South or Central American, or other Spanish culture or origin, regardless of race.</li> </ul></div></div>');" class="uk-dark uk-light use-hand-cursor theme-primary-bg-color" style="top: -55px; float: right; margin-right: 5.85px; padding: 0px; font-size: 14px; background-color: #6495d1; width: 20px; height: 20px; display: block; border-radius: 10px; text-align: center; color:white">?</a></label>
                                <validated-section :errors="errors" field="applicant_ethnicity">
                                <select :aria-label="__('tenant.ethnicity')" v-model="applicant.ethnicity_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.ethnicities" :key="item.id" :value="item.id">{{item.ethnicity_desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <div class="uk-width-medium-1-4 uk-margin-bottom">
                                <label>{{ __('tenant.gender') }}:</label>
                                <validated-section :errors="errors" field="applicant_sex">
                                <select :aria-label="__('tenant.gender')" v-model="applicant.sex_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.genders" :key="item.id" :value="item.id">{{item.gender_desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <div class="uk-width-medium-1-4 uk-margin-bottom">
                                <label>{{ __('tenant.primary_language') }}:</label>
                                <validated-section :errors="errors" field="applicant_primary_language">
                                <select :aria-label="__('tenant.primary_language')" v-model="applicant.language_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.languages" :key="item.id" :value="item.id">{{item.language_desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-military-status']">
                                <label>{{ __('tenant.military_status') }}:</label>
                                <validated-section :errors="errors" field="applicant_military_status">
                                <select :aria-label="__('tenant.military_status')" v-model="applicant.militray_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.militaryStatus" :key="item.id" :value="item.id">{{item.military_status_desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-legal-status']">
                                <label>{{ __('tenant.legal_status') }}:</label>
                                <validated-section :errors="errors" field="applicant_legal_status">
                                <select :aria-label="__('tenant.legal_status')" v-model="applicant.legal_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.legalStatus" :key="item.id" :value="item.id">{{item.legal_status_desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-education']">
                                <label>{{ __('tenant.education') }}:</label>
                                <validated-section :errors="errors" field="applicant_education">
                                <select :aria-label="__('tenant.education')" required v-model="applicant.education_id" class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.education" :key="item.id" :value="item.id" :selected="item.id === applicant.education_id">{{item.education_desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-disabled']">
                                <label>{{ __('tenant.disabled') }}?:</label>
                                <validated-section :errors="errors" field="applicant_disabled">
                                <select :aria-label="__('tenant.disabled')" v-model="applicant.disabled_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.disabled" :key="item.id" :value="item.id">{{item.disabled_desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-work-status']">
                                <label>{{ __('tenant.work_status') }}:</label>
                                <validated-section :errors="errors" field="applicant_work_status">
                                <select :aria-label="__('tenant.work_status')" v-model="applicant.work_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.workStatus" :key="item.id" :value="item.id">{{item.work_status_desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-disconnected-status']">
                                <label>{{ __('tenant.disconnected_status') }}?:</label>
                                <validated-section :errors="errors" field="applicant_disconnected_status">
                                <select :aria-label="__('tenant.disconnected_status')" v-model="applicant.disconnected_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.disconnectedStatus" :key="item.id" :value="item.id">{{item.disconnected_statuse_desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-marital-status']">
                                <label>{{ __('tenant.marital_status') }}?:</label>
                                <validated-section :errors="errors" field="applicant_marital_status">
                                <select :aria-label="__('tenant.marital_status')" v-model="applicant.marital_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.maritalStatus" :key="item.id" :value="item.id">{{item.marital_statuse_desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-health-insurance-status']">
                                <label>{{ __('tenant.health_insurance') }}:</label>
                                <validated-section :errors="errors" field="applicant_health_insurance">
                                <select :aria-label="__('tenant.health_insurance')" v-model="applicant.health_insurance_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.healthInsurance" :key="item.id" :value="item.id">{{item.desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-person-characteristics']">
                                <label>{{ __('tenant.personal_characteristic') }}:</label>
                                <validated-section :errors="errors" field="applicant_personal_characteristic">
                                <select :aria-label="__('tenant.personal_characteristic')" v-model="applicant.person_characteristic_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.personCharacteristic" :key="item.id" :value="item.id">{{item.desc}}</option>
                                </select>
                                </validated-section>
                            </div>
                            <div class="uk-width-medium-1-4 uk-margin-bottom">
                                <label>{{ __('tenant.hh_size') }}:</label>
                                <validated-section :errors="errors" field="applicant_household_size">
                                <select :aria-label="__('tenant.hh_size')" v-model="applicant.household_size_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                    <option :value="null" selected>_</option>
                                    <option v-for="item in assets.householdSize.filter(size => size.household_size > 0)" :key="item.id" :value="item.id">{{item.household_size_description}}</option>
                                </select>
                                </validated-section>
                                <small v-if="application.program.slug === 'mrap'">To determine household size click <a uk-tooltip title="HOW TO CALCULATE HOUSEHOLD SIZE" onclick="UIkit.modal.alert('<div class=\'uk-grid\'> <div class=\'uk-width-1-1 uk-margin-bottom\'> <h1>Calculating Household Size</h1> <p>Household members includes all adults and children living in the unit, including the following:</p> <ul> <li>Children temporarily absent due to placement in a foster home</li> <li>Children in joint custody who live in unit at least 50% of the time</li> <li>Children away at school but live with the family during recess</li> <li>Unborn children of pregnant women</li> <li>Children in the process of being adopted</li> <li>Temporarily absent family members who are still considered family members</li> <li>Family members in the hospital or rehab facility for limited or fixed time</li> <li>Persons permanently confined to a hospital or nursing home.</li> </ul> <p>Household members do not include:</p> <ul> <li>Live-in aides</li> <li>Guests</li> <li>Individuals in the same residence that have a separate lease obligation</li></ul> </div></div>');">HERE</a>.</small>
                            </div>

                            <template v-if="programSettings['uses-school-fields']">
                                <div class="uk-width-medium-1-4 uk-margin-bottom">
                                    <label>{{ __('tenant.school_district') }}:</label>
                                    <validated-section :errors="errors" :field="`member_0_school_district`">
                                        <select aria-label="School District" v-model="applicant.school_district_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.schoolDistricts" :key="item.value" :value="item.value">{{item.body}}</option>
                                            <option value="-1">Not Applicable</option>
                                            <option value="-2">Unknown</option>
                                        </select>
                                    </validated-section>
                                </div>
                                <div class="uk-width-medium-1-4 uk-margin-bottom">
                                    <validated-section :errors="errors" :field="`member_0_school_name`">
                                        <label>{{ __('tenant.school_name') }}:</label>
                                        <input type="text" :placeholder="__('tenant.school_name')" class="uk-width-1-1 uk-margin-bottom uk-form-large" v-model="applicant.school_name">
                                    </validated-section>
                                </div>
                                <div class="uk-width-medium-1-4 uk-margin-bottom">
                                    <validated-section :errors="errors" :field="`member_0_grade_level`">
                                        <label>{{ __('tenant.grade_level') }}:</label>
                                        <input type="text" :placeholder="__('tenant.grade_level')" class="uk-width-1-1 uk-margin-bottom uk-form-large" v-model="applicant.grade_level">
                                    </validated-section>
                                </div>
                            </template>

                            <div class="uk-width-medium-1-4">&nbsp;</div>
                        </div>
                        <div class="uk-grid">
                            <div class="uk-width-medium-1-4 uk-width-small-1-1">
                                <validated-section :errors="errors" field="applicant_ssn">
                                <label>{{ __('tenant.ssn') }}<span v-if="!programSettings['require-applicant-social-security-number']"> (NOT REQUIRED) </span>:</label>
                                <input name="pa_ssn" v-mask="'###-##-####'" pattern="[0-9]{9}"  type="text" :placeholder="__('tenant.ssn_full')" class="uk-width-1-1 uk-margin-bottom uk-form-large" v-model="applicant.ssn" :disabled="lockSSN">
                                </validated-section>
                                <div v-if="showHhmIdSsnCheckbox" class="uk-margin uk-grid-small uk-child-width-auto uk-grid">
                                    <label><input v-model="applicant.use_hhmid_as_ssn" class="uk-checkbox" type="checkbox"> Use my unique ID number on this site as my SSN</label>
                                </div>
                            </div>
                            <div class="uk-width-medium-1-4 uk-width-small-1-1" v-if="programSettings['use-itin']">
                                <label>{{ __('tenant.itin') }}:</label>
                                <input name="pa_itin" v-mask="'###-##-####'" pattern="[0-9]{9}"  type="text" :placeholder="__('tenant.itin')" class="uk-width-1-1 uk-margin-bottom uk-form-large" v-model="applicant.itin"  :disabled="lockSSN">
                            </div>
                            <div class="uk-width-1-1 uk-margin-bottom" v-if="programSettings['uses-plan-sustainable-income-question']">
                                <CustomTextarea
                                        :rows="3"
                                        name="Sustainable Income"
                                        label="What is your plan moving forward for sustainable income to cover your housing cost?"
                                        v-model="applicant.sustainable_income"
                                        rules="required"
                                />
                            </div>
                            <div class="uk-width-1-1 uk-margin-bottom" v-if="programSettings['uses-explain-need-for-assistance-question']">
                                <CustomTextarea
                                        :rows="3"
                                        name="Situation"
                                        label="Please explain situation and need for assistance (if COVID-19 related, please explain how)"
                                        v-model="applicant.need_for_assistance"
                                        rules="required"
                                />
                            </div>
                            <template v-if="programSettings['uses-last-payment-date']">
                                <div class="uk-width-small-1-1 uk-width-medium-1-2  uk-width-small-1-1 uk-margin-bottom">
                                    <date-picker
                                            name="LastPay"
                                            label="When did you last make a payment?"
                                            v-model="applicant.last_pay_rent"
                                            :config="datePickerConfig"
                                            placeholder="Select Date"
                                            rules="required"
                                    />
                                </div>
                                <div class="uk-width-small-1-1 uk-width-medium-1-2 uk-margin-bottom" v-if="programSettings['uses-how-much-pay-question']">
                                    <label>How Much did you pay?:</label>
                                    <TextInput
                                            type="number"
                                            v-model="applicant.your_pay"
                                            name="Your Pay"
                                            placeholder="Your Pay"
                                            rules="required"
                                            label="Your Pay"
                                    />
                                </div>
                            </template>
                            <div class="uk-width-1-1 uk-margin-bottom" v-if="programSettings['uses-income-past30-question']">
                                <label>Have you had income for the past 30 days?</label>
                                <div class="uk-margin-top">
                                    <label class="uk-display-inline"><input type="radio" value="1" v-model="applicant.has_income_30_days"> Yes</label>
                                    <label class="uk-display-inline uk-margin-left"><input type="radio" value="0" v-model="applicant.has_income_30_days"> No</label>
                                </div>
                                <TextInput
                                        v-if="applicant.has_income_30_days == '1'"
                                        type="number"
                                        v-model="applicant.income_30_days"
                                        name="Amount"
                                        placeholder="Amount"
                                        rules="required"
                                />
                            </div>
                            <div class="uk-width-1-1 uk-margin-bottom" v-if="programSettings['uses-income-able-to-pay-question']">
                                <label>Do you have income to pay rent/mortgage going forward?</label>
                                <div class="uk-margin-top">
                                    <label class="uk-display-inline"><input type="radio" name="pa_rent_mortgage" value="1" v-model="applicant.rent_mortgage"> Yes</label>
                                    <label class="uk-display-inline uk-margin-left"><input type="radio" name="pa_rent_mortgage" value="0" v-model="applicant.rent_mortgage"> No</label>
                                </div>
                            </div>
                            <div class="uk-width-1-1 uk-margin-bottom" v-if="programSettings['uses-homeless-question']">
                                <label>If you aren't able to receive assistance through {{ application.program.program_abbreviation }}, will you be homeless?</label>
                                <div class="uk-margin-top">
                                    <label class="uk-display-inline"><input type="radio" name="pa_homeless" value="1" v-model="applicant.homeless"> Yes</label>
                                    <label class="uk-display-inline uk-margin-left"><input type="radio" name="pa_homeless" value="0" v-model="applicant.homeless"> No</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="uk-grid-divider uk-margin-bottom uk-margin-top app-fades" style="border:none;" >
                    <legend class="app-fades">{{ __('tenant.primary_contact_info') }}</legend>
                    <div class="uk-container" >
                        <div class="uk-grid" data-uk-margin>
                            <div class="uk-width-medium-5-10 uk-margin-bottom">
                                <template v-if="env.REQUIRE_PHONE_NUMER">
                                    <phone-number-input
                                        :name="__('tenant.primary_phone')"
                                        v-model="applicant.primary_contact.formatted_number"
                                        :label="__('tenant.primary_phone')"
                                        rules="required"
                                    />
                                </template>
                                <template v-else>
                                    <phone-number-input
                                        :name="__('tenant.primary_phone')"
                                        v-model="applicant.primary_contact.formatted_number"
                                        :label="__('tenant.primary_phone')" />
                                </template>
                            </div>
                            <div class="uk-width-medium-5-10 uk-margin-bottom">
                                <phone-number-input
                                        :name="__('tenant.secondary_phone')"
                                        v-model="applicant.secondary_contact.formatted_number"
                                        :label="__('tenant.secondary_phone')"
                                />
                            </div>
                        </div>
                        <hr class="uk-grid-divider" style="clear:both; border:none" >
                        <label v-if="programSettings['confidential-address-program']">
                            <input type="checkbox" name="confidential_address_program" v-model="applicant.confidential_address_program">
                            {{ __('tenant.confidential_address_program_desc') }}
                            <br /><br />
                        </label>

                        <div class="uk-form-row uk-margin-bottom" >
                            <p class="uk-margin-bottom-remove"><small>&nbsp;{{ __('tenant.property_address') }}:</small></p>
                            <div class="uk-grid" >
                                <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1 uk-margin-small-top">
                                    <label>{{ __('tenant.property_address_line_1') }}</label>
                                    <AddressAutocomplete
                                        :street-address="applicant.property_address.line_1"
                                        @updated="updatePropertyAddressFromAutocomplete"
                                        placeholder="Street Address"
                                        name="Line1"
                                        :disabled="isHomeless"
                                    />
                                </div>
                                <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1 uk-margin-small-top">
                                    <label>{{ __('tenant.property_address_line_2') }}</label>
                                    <TextInput
                                            v-model="applicant.property_address.line_2"
                                            name="Line2"
                                            placeholder="Unit"
                                            :disabled="isHomeless"
                                    />
                                </div>
                                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                                    <label>{{ __('tenant.property_address_city') }}</label>
                                    <TextInput
                                            v-model="applicant.property_address.city"
                                            name="City"
                                            placeholder="City"
                                            rules="required"
                                            :disabled="isHomeless"
                                    />
                                </div>
                                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                                    <label>{{ __('tenant.property_address_state') }}</label>
                                    <select :aria-label="__('tenant.property_address_state')" v-model="applicant.property_address.state_id" class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large" :disabled="isHomeless">
                                        <option :value="null" selected>_</option>
                                        <option v-for="item in assets.states" :value="item.id" :key="item.id">{{item.state_name}}</option>
                                    </select>
                                </div>
                                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                                    <label>{{ __('tenant.property_address_zip') }}</label>
                                    <TextInput
                                            v-model="applicant.property_address.zip"
                                            name="Zip"
                                            placeholder="Zip"
                                            rules="required"
                                            :disabled="isHomeless"
                                    />
                                </div>
                                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                                    <label>{{ __('tenant.property_address_county') }}</label>
                                    <select :aria-label="__('tenant.property_address_county')" v-model="applicant.property_address.county_id" class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                        <option :value="null" selected>_</option>
                                        <option v-for="item in filteredCounties" :value="item.id" :key="item.id">{{item.county_name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <br /><br />
                        <label >
                            <input type="checkbox" name="is_mail_address_same" onChange="$('#mailing-address').slideToggle();" class="" v-model="applicant.is_mail_address_same">
                            Primary Applicant's mailing address is the same as the property address.</label>
                        <div id="mailing-address" class="uk-form-row uk-margin-top" v-if="!applicant.is_mail_address_same">
                            <div class="uk-margin-large-bottom"><small>&nbsp;PRIMARY APPLICANT'S MAILING ADDRESS:</small></div>
                            <div class="uk-grid" >
                                <div class="uk-width-3-5 uk-width-medium-1-2 uk-width-small-1-1 uk-margin-small-top">
                                    <label>{{ __('tenant.mailing_address_line_1') }}</label>

                                    <TextInput
                                            v-model="applicant.mail_address.line_1"
                                            name="Line1"
                                            placeholder="Street Address"
                                            rules="required"
                                    />
                                </div>
                                <div class="uk-width-3-5 uk-width-medium-1-2 uk-width-small-1-1 uk-margin-small-top">
                                    <label>{{ __('tenant.mailing_address_line_2') }}</label>
                                    <TextInput
                                            v-model="applicant.mail_address.line_2"
                                            name="Line2"
                                            placeholder="Unit"
                                    />
                                </div>
                                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                                    <label>{{ __('tenant.mailing_address_city') }}</label>
                                    <TextInput
                                            v-model="applicant.mail_address.city"
                                            name="City"
                                            placeholder="City"
                                            rules="required"
                                    />
                                </div>
                                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                                    <label>{{ __('tenant.mailing_address_state') }}</label>
                                    <validated-section :errors="errors" field="applicant_mail_address_state">
                                        <select v-model="applicant.mail_address.state_id" class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.states" :value="item.id" :key="item.id">{{item.state_name}}</option>
                                        </select>
                                    </validated-section>
                                </div>
                                <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                                    <label>{{ __('tenant.mailing_address_zip') }}</label>
                                    <TextInput
                                            v-model="applicant.mail_address.zip"
                                            name="Zip"
                                            placeholder="Zip"
                                            rules="required"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <br /><br />
                    <div class="uk-container uk-margin-top " >
                        <div class="uk-grid">
                            <div class="uk-panel uk-panel-box uk-width-1-1">
                                <span class="uk-panel-title"><i class="uk-icon-home uk-icon-large"></i> <u>{{ __('tenant.property_details') }}</u></span>
                                <div class="uk-panel-body">
                                    <legend>{{ __('tenant.property_is') }}:</legend>
                                    <template v-if="showPropertyAsOptions">
                                        <validated-section :errors="errors" field="property_is">
                                        </validated-section>
                                        <div class="uk-grid">
                                            <div class="uk-width-medium-1-1 uk-margin-bottom">
                                                <input  type="radio" v-model="primaryResidenceToggle" name="property-detail-residence-is" value="property" class=" xuk-form-large" aria-labelledby="is-primary-residence-txt" id="is-primary-residence-txt">
                                                <label for="is-primary-residence-txt">{{ __('tenant.primary_residence') }}</label>
                                            </div>
                                            <div class="uk-width-medium-1-1 uk-margin-bottom" v-if="programSettings['uses-homeless-application']">
                                                <input  type="radio" v-model="primaryResidenceToggle" name="property-detail-residence-is" value="homeless" class=" xuk-form-large" aria-labelledby="is-homeless-txt" id="is-homeless-txt">
                                                <label for="is-homeless-txt">{{ __('tenant.is_homeless') }}</label>
                                            </div>
                                            <div class="uk-width-medium-1-1" v-if="programSettings['uses-vacated-status']">
                                                <input type="radio" v-model="primaryResidenceToggle" name="property-detail-residence-is" value="vacated" class=" xuk-form-large" aria-labelledby="is-vacated-txt" id="is-vacated-txt">
                                                <label for="is-vacated-txt">{{ __('tenant.is_vacated') }}</label>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                      <div class="uk-grid uk-margin-bottom">
                                        <div class="uk-width-medium-1-1">
                                          <input  type="checkbox" v-model="applicant.is_primary_residence" name="property-detail-residence-is" value="1" class=" xuk-form-large" aria-labelledby="is-primary-residence-txt">
                                          <span id="is-primary-residence-txt">{{ __('tenant.primary_residence') }}</span>
                                        </div>
                                      </div>
                                    </template>


                                    <div id="property-unit-wrapper" v-if="submitData.mainType === 'homeowner' && applicant.is_primary_residence">
                                        <legend><br />
                                            {{ __('tenant.property_is') }}:
                                        </legend>
                                        <div class="uk-grid uk-margin-bottom">
                                            <div class="uk-width-medium-1-3 uk-margin-bottom">
                                                <label >
                                                    <input v-model="applicant.property" type="radio" id="property-1" name="property-detail-is" value="1">
                                                    1 Unit</label>
                                            </div>
                                            <div class="uk-width-medium-1-3 uk-margin-bottom">
                                                <label >
                                                    <input v-model="applicant.property"  type="radio" id="property-2" name="property-detail-is" value="2">
                                                    2 Units</label>
                                            </div>
                                            <div class="uk-width-medium-1-3 uk-margin-bottom">
                                                <label >
                                                    <input v-model="applicant.property"  type="radio" id="property-3" name="property-detail-is" value="3">
                                                    3 Units</label>
                                            </div>
                                            <div class="uk-width-medium-1-3 uk-margin-bottom">
                                                <label >
                                                    <input v-model="applicant.property"  type="radio" id="property-4" name="property-detail-is" value="4">
                                                    4 Units</label>
                                            </div>
                                            <div class="uk-width-medium-1-3  uk-margin-bottom">
                                                <label >
                                                    <input v-model="applicant.property" value="5" type="radio" id="property-5" name="property-detail-is">
                                                    Manufactured or Mobile Home.</label>
                                            </div>
                                            <div class="uk-width-1-1 uk-text-center" v-if="applicant.property == 5">
                                                <label>
                                                <input  type="checkbox">
                                                I confirm that my manufactured or mobile home is titled as real estate.</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- APPEND ADDITIONAL APPLICANTS HERE -->
                    <div class="hh-member-wrapper">
                        <div v-for="(member, index) in hhMembers" :key="index" class="household-memeber-form clonedInput">
                            <br /><br />
                            <legend class="app-fades">{{ __('tenant.household_member') }}<span> {{ index + 2 }}</span></legend>
                            <div class="uk-container " >
                                <div class="uk-grid">

                                    <div class="uk-width-small-1-1 uk-width-medium-1-4">
                                        <date-picker
                                                :name="__('tenant.birth_date')"
                                                :label="__('tenant.birth_date')"
                                                v-model="member.birth_date"
                                                :config="datePickerConfig"
                                                :placeholder="__('tenant.birth_date')"
                                                rules="required"
                                                @changed="onChangeMemberBday(member, index)"
                                        />
                                    </div>
                                    <div class="uk-width-small-1-1 uk-width-medium-3-4 ">
                                        <label>{{ __('tenant.type') }}:</label>
                                        <div class="styled-select uk-margin-bottom">
                                            <select :aria-label="__('tenant.type')" v-model="member.type" class="uk-button uk-form-select uk-form-large app-type">
                                                <option>_</option>
                                                <option v-for="relation in assets.hhRelations" :key="relation.id" :value="relation.id">{{ relation.household_relationship_desc }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="uk-width-medium-1-2 uk-margin-bottom">
                                        <TextInput
                                                v-model="member.first_name"
                                                :name="__('tenant.first_name')"
                                                :placeholder="__('tenant.first_name')"
                                                :label="__('tenant.first_name')"
                                                :disabled="(programSettings['hide-minor-household-member-names'] && _getAge(member.birth_date) < 18)"
                                                rules="required"
                                        />
                                    </div>
                                    <div class="uk-width-medium-1-2 uk-margin-bottom">
                                        <TextInput
                                                v-model="member.last_name"
                                                :name="__('tenant.last_name')"
                                                :placeholder="__('tenant.last_name')"
                                                :label="__('tenant.last_name')"
                                                :disabled="(programSettings['hide-minor-household-member-names'] && _getAge(member.birth_date) < 18)"
                                                rules="required"
                                        />
                                    </div>


                                </div>
                                <div class="uk-grid">
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['show-household-member-social']">
                                      <validated-section :errors="serverValidationErrors" :field="`hhMembers.${index}.social_security_number`">
                                        <label>{{ __('tenant.ssn') }} <span v-if="!programSettings['require-applicant-social-security-number']"> {{ __('tenant.not_required') }} </span>:</label>
                                        <input name="pa_ssn" v-mask="'###-##-####'" pattern="[0-9]{9}"  type="text" placeholder="Social Security Number" class="uk-width-1-1 uk-margin-bottom uk-form-large" v-model="member.social_security_number" :disabled="lockSSN">
                                      </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.race') }}:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_race`">
                                        <select :aria-label="__('tenant.race')" v-model="member.race_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.races" :key="item.id" :value="item.id">{{item.race_desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.ethnicity') }}:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_ethnicity`">
                                        <select :aria-label="__('tenant.ethnicity')" v-model="member.ethnicity_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.ethnicities" :key="item.id" :value="item.id">{{item.ethnicity_desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.gender') }}:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_gender`">
                                        <select :aria-label="__('tenant.gender')" v-model="member.gender_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.genders" :key="item.id" :value="item.id">{{item.gender_desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.primary_language') }}:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_primary_language`">
                                        <select :aria-label="__('tenant.primary_language')" v-model="member.primary_language_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.languages" :key="item.id" :value="item.id">{{item.language_desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-military-status'] && programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.military_status') }}:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_military_status`">
                                        <select :aria-label="__('tenant.military_status')" v-model="member.military_status_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.militaryStatus" :key="item.id" :value="item.id">{{item.military_status_desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-household-relationship-question'] && programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.relationship_to_head_household') }}?:</label>
                                        <select :aria-label="__('tenant.relationship_to_head_household')" v-model="member.household_relationship_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.hhRelations" :key="item.id" :value="item.id">{{item.household_relationship_desc}}</option>
                                        </select>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-legal-status'] && programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.legal_status') }}:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_legal_status`">
                                        <select :aria-label="__('tenant.legal_status')" v-model="member.legal_status_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.legalStatus" :key="item.id" :value="item.id">{{item.legal_status_desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-education'] && programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.education') }}:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_education`">
                                        <select :aria-label="__('tenant.education')" v-model="member.education_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.education" :key="item.id" :value="item.id">{{item.education_desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-disabled'] && programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.disabled') }}?:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_disabled`">
                                        <select :aria-label="__('tenant.disabled')" v-model="member.disabled_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.disabled" :key="item.id" :value="item.id">{{item.disabled_desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom"  v-if="programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.work_status') }}:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_work_status`">
                                        <select :aria-label="__('tenant.work_status')" v-model="member.work_status_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.workStatus" :key="item.id" :value="item.id">{{item.work_status_desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-disconnected-status'] && programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.disconnected_status') }}?:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_disconnected_status`">
                                        <select :aria-label="__('tenant.disconnected_status')" v-model="member.disconnected_status_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.disconnectedStatus" :key="item.id" :value="item.id">{{item.disconnected_statuse_desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-marital-status'] && programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.marital_status') }}?:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_marital_status`">
                                        <select :aria-label="__('tenant.marital_status')" v-model="member.marital_status_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.maritalStatus" :key="item.id" :value="item.id">{{item.marital_statuse_desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-health-insurance-status'] && programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.health_insurance') }}:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_health_insurance`">
                                        <select :aria-label="__('tenant.health_insurance')" v-model="member.health_insurance_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.healthInsurance" :key="item.id" :value="item.id">{{item.desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-1-4 uk-margin-bottom" v-if="programSettings['uses-person-characteristics'] && programSettings['show-hhm-demographics']">
                                        <label>{{ __('tenant.personal_characteristic') }}:</label>
                                        <validated-section :errors="errors" :field="`member_${index}_personal_characteristic`">
                                        <select aria-label="Person Characteristics" v-model="member.person_characteristic_id" required class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                                            <option :value="null" selected>_</option>
                                            <option v-for="item in assets.personCharacteristic" :key="item.id" :value="item.id">{{item.desc}}</option>
                                        </select>
                                        </validated-section>
                                    </div>
                                </div>
                                <div>
                                    <button v-if="member.household_member_key != '1'" class="uk-button uk-button-mini uk-width-1-1 uk-width-medium-1-3 uk-push-2-3 uk-margin-top" @click="removeHHMember(index);"><i class="uk-icon-times"></i>{{ __('tenant.remove_member') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- END APPENDING APPLICANTS -->
                    <br /> <br />
                    <hr class="uk-grid-divider uk-margin-bottom uk-margin-top app-fades"  >
                    <p id="AdditionalQualifyingApplicantQuestion" class="uk-text-center">{{ __('tenant.is_another_member') }}?<br /></p>
                    <div class="uk-grid uk-margin-large-bottom">

                        <div class="uk-width-1-1 uk-text-center">
                            <button class="uk-button uk-width-small-1-1 uk-width-medium-1-3 uk-form-large" @click="addHHMember()"><i class="uk-icon-plus-square-o" id="ApplicantYes"></i> {{ __('tenant.add_member') }} </button>
                        </div>

                    </div>
                </fieldset>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    import AddressAutocomplete from "../../../../../../components/AddressAutocomplete.vue";

    export default {
        name: "Step1",
        props: {
            print: {
                type: Boolean,
                default: false,
            }
        },
        components: {AddressAutocomplete, ValidatedSection },
        data() {
            return {
                errors: {},
                loading: false,
                serverValidationErrors: {},

                applicantDatePickerConfig: {
                    wrap: true, // set wrap to true only when using 'input-group'
                    altFormat: 'M j, Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    maxDate: moment().subtract(18, 'years').toDate(),
                },
                datePickerConfig: {
                    wrap: true, // set wrap to true only when using 'input-group'
                    altFormat: 'M j, Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                },
                submitData: {
                    mainType: 'renter',
                    projectName: '',
                    isSameManager: true,
                },

              primaryResidenceToggle: null,
            }
        },

        mounted() {
            if(this.application) {
                this.submitData.mainType = this.application.home_owner ? 'homeowner' : 'renter'
                this.submitData.projectName = this.application.project_name
                this.submitData.isSameManager = this.application.is_renter_same_manager
                if (this.application.is_vacated && this.programSettings['uses-vacated-status']) {
                     this.primaryResidenceToggle = 'vacated';
                } else if (this.application.is_homeless && this.programSettings['uses-homeless-application']) {
                     this.primaryResidenceToggle = 'homeless';
                } else if(this.applicant.is_primary_residence) {
                    this.primaryResidenceToggle = 'property';
                }
            }
        },

        watch: {
            'application': {
                handler: function(newValue, oldValue) {
                    if (newValue)
                    {
                        this.submitData.mainType = newValue.home_owner ? 'homeowner' : 'renter'
                        this.submitData.projectName = newValue.project_name
                        this.submitData.isSameManager = newValue.is_renter_same_manager;
                        if(this.applicant.is_primary_residence) {
                          this.primaryResidenceToggle = 'property';
                        }else if (newValue.is_vacated) {
                          this.primaryResidenceToggle = 'vacated';
                        }else if (newValue.is_homeless) {
                          this.primaryResidenceToggle = 'homeless';
                        }
                    }
                },
                deep: true,
            },
            'loading': {
                handler: function(newValue, oldValue) {
                    this.$isLoading(newValue)
                },
            },
            'applicant.household_size_id': {
                handler: function(newValue, oldValue) {
                    if (newValue)
                    {
                        const hhSizeItem = this.assets.householdSize.find(item => item.id == newValue)
                        let data = this.hhMembers.filter(item => item.first_name || item.last_name)
                        if (hhSizeItem.household_size_key > data.length)
                        {
                            data = data.concat(Array.from({length: hhSizeItem.household_size_key - data.length - 1}, (x, i) => { return { type: 2 }}))
                        }
                        this.$store.dispatch('Application/updateHHMember', data)
                    }
                },
            },
            'primaryResidenceToggle': {
                handler: function(newValue, oldValue) {
                    if (oldValue && newValue != oldValue && newValue == 'homeless')
                    {
                        UIkit.modal.confirm('Are you sure you want to change property type to Homeless? Property manager will be set as default.')
                            .then((res) => {
                                this.setAppHomeless();
                            })
                            .catch(() => {
                                this.primaryResidenceToggle = oldValue
                            });
                    }
                }
            }
        },

        computed: {
            lockSSN() {
                return this.programSettings['use-hhm-id-as-ssn'] && !!this.applicant.use_hhmid_as_ssn
            },

            showHhmIdSsnCheckbox() {
                return this.programSettings['use-hhm-id-as-ssn'] &&
                    (
                    !this.programSettings['require-applicant-social-security-number'] ||
                    this.programSettings['require-applicant-social-security-number'] && this.errors['applicant_ssn']
                    )
            },

            showPropertyAsOptions() {
                return this.programSettings['uses-vacated-status'] || this.programSettings['uses-homeless-application']
            },
            isHomeless() {
                return this.programSettings['uses-homeless-application'] && this.primaryResidenceToggle === 'homeless'
            },
            user() {
                return this.$store.getters['App/user']
            },
            filteredCounties() {
                if(this.applicant.property_address.state_id) {
                    return _.filter(this.assets.counties, county => {
                        return county.state_id === this.applicant.property_address.state_id;
                    })
                }
                return [];
            },
            ...mapState('App', {
                usingScreenReader: 'usingScreenReader',
                env: state => state.env,
            }),
            ...mapState('Application', {
                assets: 'assets',
                application: 'application',
                applicant: 'applicant',
                hhMembers: 'hhMembers',
                renterManager: 'renterManager',
                renterOwner: 'renterOwner',
                organization: 'organization',
                program: state => state.application.program,
            }),
            ...mapGetters('Application', [ 'programSettings', 'defaultProject' ]),
        },

        methods: {
          updatePropertyAddressFromAutocomplete(addressData) {
            console.log('Updating property address: ', addressData);
            this.applicant.property_address.line_1 = addressData.line_1;
            this.applicant.property_address.city = addressData.city;
            this.applicant.property_address.state = addressData.state;
            this.applicant.property_address.state_id = addressData.state_id;
            this.applicant.property_address.county_id = addressData.county_id;
            this.applicant.property_address.zip = addressData.zip;

          },
            setLoading(val)
            {
                this.loading = val
            },

            setAppHomeless() {
                this.applicant.property_address = this.defaultProject.address
            },

            removeHHMember(index) {
                this.$store.dispatch('Application/removeHHMember', index)
            },
            addHHMember() {
                this.$store.dispatch('Application/addHHMember')
            },

            updatePropertyAddress(propertyResult) {
                this.applicant.property_address.line_1 = propertyResult.address.line_1;
                this.applicant.property_address.city = propertyResult.address.city;
                this.applicant.property_address.state = propertyResult.address.state;
                this.applicant.property_address.state_id = propertyResult.address.state_id;
                this.applicant.property_address.zip = propertyResult.address.zip;
            },

            scrollToErrorField() {
                const errors = Object.entries(this.$refs.applicantForm.errors)
                    .map(([key, value]) => ({ key, value }))
                    .filter(error => error["value"].length);
                if (errors && errors.length)
                {
                    this.$refs.applicantForm.refs[errors[0]["key"]].$el.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                } else {
                    this.scrollTop();
                }
            },

            scrollTop: function () {
                if (window.pageYOffset > 0) {
                    this.intervalId = setInterval(() => {
                        if (window.pageYOffset === 0) {
                            clearInterval(this.intervalId)
                        }
                        window.scroll(0, window.pageYOffset - 50)
                    }, 5)
                }
            },

            _getAge(birthday) {
                let dob = moment(birthday);
                let now = moment();
                return Math.abs(now.diff(dob, 'years'));
            },

            async onChangeMemberBday(member, idx) {
                if (member.birth_date)
                {
                    let age = this._getAge(member.birth_date);
                    console.log(member.birth_date, age)
                    if(!this.programSettings['allows-minor-household-members']) {
                        if(age < 18) {
                            await UIkit.modal.confirm('You are not required to enter information about your children that are younger than 18 years of age for this program. Click here to and we will remove the request for their information.', () => {
                                this.removeHHMember(idx);
                            }, () => {
                                this.removeHHMember(idx);
                            });
                        }
                    }else if (!this.programSettings['requires-minor-household-member-documentation']) {

                    }

                    if(this.programSettings['hide-minor-household-member-names']) {
                        if(age < 18) {
                            this.hhMembers[idx].first_name = 'Minor Household';
                            this.hhMembers[idx].last_name = 'Member ' + (idx + 1);
                        }else {
                            if (this.hhMembers[idx].first_name == 'Minor Household')
                            {
                                this.hhMembers[idx].first_name = '';
                                this.hhMembers[idx].last_name = '';
                            }
                        }

                    }
                }
            },

            checkHHMemberAge() {
                let applicantAge = this._getAge(this.applicant.dob);
                if(applicantAge < 18) return false;
                return true;
            },

            async validateStep() {
                this.errors = {}
                let stepValid = false;

                let customValid = true;

                if (this.programSettings['demographics-required-applicant'])
                {
                    if (this.applicant.race_id == undefined)
                    {
                        this.errors['applicant_race'] = { errors: [this.__('validation.must_select_option')]};
                    }
                    if (this.applicant.ethnicity_id == undefined)
                    {
                        this.errors['applicant_ethnicity'] = { errors: [this.__('validation.must_select_option')]};
                    }
                    if (this.applicant.sex_id == undefined)
                    {
                        this.errors['applicant_sex'] = { errors: [this.__('validation.must_select_option')]};
                    }
                    if (this.applicant.language_id == undefined)
                    {
                        this.errors['applicant_primary_language'] = { errors: [this.__('validation.must_select_option')]};
                    }
                    if (this.applicant.militray_id == undefined && this.programSettings['uses-military-status'])
                    {
                        this.errors['applicant_military_status'] = { errors: [this.__('validation.must_select_option')]};
                    }
                    if (this.applicant.legal_id == undefined && this.programSettings['uses-legal-status'])
                    {
                        this.errors['applicant_legal_status'] = { errors: [this.__('validation.must_select_option')]};
                    }
                    if (this.applicant.education_id == undefined && this.programSettings['uses-education'])
                    {
                        this.errors['applicant_education'] = { errors: [this.__('validation.must_select_option')]};
                    }
                    if (this.applicant.disabled_id == undefined && this.programSettings['uses-disabled'])
                    {
                        this.errors['applicant_disabled'] = { errors: [this.__('validation.must_select_option')]};
                    }
                    if (this.applicant.work_id == undefined && this.programSettings['uses-work-status'])
                    {
                        this.errors['applicant_work_status'] = { errors: [this.__('validation.must_select_option')]};
                    }
                    if (this.applicant.disconnected_id == undefined && this.programSettings['uses-disconnected-status'])
                    {
                        this.errors['applicant_disconnected_status'] = { errors: [this.__('validation.must_select_option')]};
                    }
                    if (this.applicant.marital_id == undefined && this.programSettings['uses-marital-status'])
                    {
                        this.errors['applicant_marital_status'] = { errors: [this.__('validation.must_select_option')]};
                    }
                    if (this.applicant.health_insurance_id == undefined && this.programSettings['uses-health-insurance-status'])
                    {
                        this.errors['applicant_health_insurance'] = { errors: [this.__('validation.must_select_option')]};
                    }
                    if (this.applicant.person_characteristic_id == undefined && this.programSettings['uses-person-characteristics'])
                    {
                        this.errors['applicant_personal_characteristic'] = { errors: [this.__('validation.must_select_option')]};
                    }
                }
                if (this.applicant.household_size_id == undefined)
                {
                    this.errors['applicant_household_size'] = { errors: [this.__('validation.must_select_option')]};
                }

                if (!this.applicant.is_mail_address_same && !this.applicant.mail_address.state_id)
                {
                    this.errors['applicant_mail_address_state'] = { errors: [this.__('validation.must_select_option')]};
                }

                if (this.programSettings['require-applicant-social-security-number'] && !this.applicant.ssn)
                {
                    if (!this.programSettings['use-hhm-id-as-ssn'] || !this.applicant.use_hhmid_as_ssn)
                    {
                        this.errors['applicant_ssn'] = { errors: ['This field is required.']};
                    }
                }

                for(var index in this.hhMembers) {
                  let member = this.hhMembers[index];
                  if (!member.social_security_number)
                  {
                    // this.errors[`member_${index}_ssn`] = { errors: ['You must enter a social security number.']};
                  }

                    if (this.programSettings['show-hhm-demographics'] && this.programSettings['demographics-required-member'])
                    {
                        if (member.race_id == undefined)
                        {
                            this.errors[`member_${index}_race`] = { errors: [this.__('validation.must_select_option')]};
                        }
                        if (member.ethnicity_id == undefined)
                        {
                            this.errors[`member_${index}_ethnicity`] = { errors: [this.__('validation.must_select_option')]};
                        }
                        if (member.gender_id == undefined)
                        {
                            this.errors[`member_${index}_gender`] = { errors: [this.__('validation.must_select_option')]};
                        }
                        if (member.primary_language_id == undefined)
                        {
                            this.errors[`member_${index}_primary_language`] = { errors: [this.__('validation.must_select_option')]};
                        }
                        if (member.military_status_id == undefined && this.programSettings['uses-military-status'])
                        {
                            this.errors[`member_${index}_military_status`] = { errors: [this.__('validation.must_select_option')]};
                        }
                        if (member.legal_status_id == undefined && this.programSettings['uses-legal-status'])
                        {
                            this.errors[`member_${index}_legal_status`] = { errors: [this.__('validation.must_select_option')]};
                        }
                        if (member.education_id == undefined && this.programSettings['uses-education'])
                        {
                            this.errors[`member_${index}_education`] = { errors: [this.__('validation.must_select_option')]};
                        }
                        if (member.disabled_id == undefined && this.programSettings['uses-disabled'])
                        {
                            this.errors[`member_${index}_disabled`] = { errors: [this.__('validation.must_select_option')]};
                        }
                        if (member.work_status_id == undefined && this.programSettings['uses-work-status'])
                        {
                            this.errors[`member_${index}_work_status`] = { errors: [this.__('validation.must_select_option')]};
                        }
                        if (member.disconnected_status_id == undefined && this.programSettings['uses-disconnected-status'])
                        {
                            this.errors[`member_${index}_disconnected_status`] = { errors: [this.__('validation.must_select_option')]};
                        }
                        if (member.marital_status_id == undefined && this.programSettings['uses-marital-status'])
                        {
                            this.errors[`member_${index}_marital_status`] = { errors: [this.__('validation.must_select_option')]};
                        }
                        if (member.health_insurance_id == undefined && this.programSettings['uses-health-insurance-status'])
                        {
                            this.errors[`member_${index}_health_insurance`] = { errors: [this.__('validation.must_select_option')]};
                        }
                        if (member.person_characteristic_id == undefined && this.programSettings['uses-person-characteristics'])
                        {
                            this.errors[`member_${index}_personal_characteristic`] = { errors: [this.__('validation.must_select_option')]};
                        }
                    }
                }

                if (!this.checkHHMemberAge()) {
                    this.errors['applicant_dob'] = { errors: [this.__('validation.applicant_age_18')]}
                }

                await this.$refs.applicantForm.validate().then(async (isValid) => {
                    if (isValid) {
                        if(this.showPropertyAsOptions) {
                            if(this.primaryResidenceToggle == 'property') {
                              this.applicant.is_primary_residence = 1;
                              this.application.is_vacated = 0;
                              this.application.is_homeless = 0;
                            }else if (this.primaryResidenceToggle == 'vacated' && this.programSettings['uses-vacated-status']) {
                              this.applicant.is_primary_residence = 0;
                              this.application.is_vacated = 1;
                              this.application.is_homeless = 0;
                            }else if (this.primaryResidenceToggle == 'homeless' && this.programSettings['uses-homeless-application']){
                              this.applicant.is_primary_residence = 0;
                              this.application.is_vacated = 0;
                              this.application.is_homeless = 1;
                            }else {
                              customValid = false;
                              this.errors['property_is'] = { errors: ['You must select a Property Status']};
                            }
                        }else {
                          let error_field = document.getElementById('is-primary-residence-txt');
                          if (this.applicant.is_primary_residence === 0) {
                            customValid = false;
                            error_field.setAttribute('style', 'color: red;');
                          } else {
                            error_field.setAttribute('style', 'color: black;');
                          }
                        }


                        if(customValid == true) {
                            stepValid = await this.submitForm()
                        }

                    }
                })

                if(_.size(this.errors) > 0) stepValid = false;

                if (!stepValid)
                {
                    setTimeout(() => {
                        this.scrollToErrorField()
                    }, 10);
                }

                return stepValid
            },

            async submitForm() {
                let stepValid = false
                this.$emit('loading', true)

                const payload = {
                    ...this.submitData,
                    id: this.application.id,
                    application: this.application,
                    applicant: this.applicant,
                    hhMembers: this.hhMembers,
                    renterManager: this.renterManager,
                    renterOwner: this.renterOwner,
                    organization: this.organization,
                }

                await this.$store
                    .dispatch(
                        this.application && this.application.id ? 'Application/update' : 'Application/create',
                        payload
                    )
                    .then((res) => {
                        this.$store.dispatch('Application/fetch', this.application.id);
                        this.$emit('done', res)
                        this.$emit('loading', false)
                        stepValid = true
                    })
                    .catch((err) => {
                        console.log(err.response);
                        if (err.response.data.errors) {
                            // this.$refs.createForm.setErrors(err.response.data.errors)
                            this.serverValidationErrors = err.response.data.errors;

                        }
                        this.$emit('loading', false)
                        stepValid = false
                    })

                return stepValid
            },
        }
    }
</script>

<style lang="scss" scoped>
    .step1-wrapper {
        .autocomplete-input {
            width: 100% !important;
            height: 40px !important;
            padding: 8px 6px !important;
            font-size: 16px !important;
            border-radius: 0!important;
        }
        .autocomplete-result-list {
            border-radius: 0!important;
        }
    }
</style>
